import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { userInformationAtom } from '../Services/_states';
import { authzContextAtom } from './authzState';
import { buildAuthzContext, extractGrantsFromUser } from './buildAuthzContext';

/**
 * Keeps authzContextAtom in sync with userInformationAtom app-wide.
 * Required because route guards run outside AuthorizationProvider (e.g. AppRoutes shell).
 */
export default function AuthzSync() {
  const userInfo = useRecoilValue(userInformationAtom);
  const setAuthzContext = useSetRecoilState(authzContextAtom);

  useEffect(() => {
    setAuthzContext(buildAuthzContext(userInfo, extractGrantsFromUser(userInfo)));
  }, [userInfo, setAuthzContext]);

  return null;
}
